<template>
    <BToastOrchestrator />
    <RouterView />
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/authStore';
import { useCountStore } from '@/stores/countStore';
import { useOrganisationStore } from '@/stores/organisationStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useVersionCheck } from '@/composables/useVersionCheck';
import { watch } from 'vue';
import { echo } from '@laravel/echo-vue';

useVersionCheck();
const authStore = useAuthStore();
const countStore = useCountStore();
const organisationStore = useOrganisationStore();
const notificationStore = useNotificationStore();

watch(
    () => authStore.loggedIn,
    (isLoggedIn) => {
        if (isLoggedIn) {
            countStore.fetchAllCounts();
        }
    },
    { immediate: true },
);

watch(
    () => organisationStore.current_organisation?.id,
    (newId, oldId) => {
        const echoInstance = echo();

        if (oldId) {
            echoInstance.leave(`organisation.${oldId}`);
        }

        if (newId) {
            echoInstance
                .private(`organisation.${newId}`)
                .listen(
                    'SyncErrorOccurred',
                    (event: {
                        report_source_id: number;
                        name: string;
                        consecutive_sync_errors: number;
                        last_sync_error_message: string;
                        last_sync_error_at: string;
                    }) => {
                        notificationStore.addSyncNotification(event);
                    },
                );
        }
    },
    { immediate: true },
);
</script>

<style lang="scss"></style>
